import React, {Fragment} from 'react'

import BkFlowMaterialLoader  from '../elements/BkFlowMaterialLoader'

const BkFlowPaymentSubmit = props => {
  const {
    dsp2TransactionLoading,
    hotelLabels,
    handleSubmitReservations,
    isFormExternal,
    pspSessionIdLoading,
    reservationLoading,
    transactionTokenLoading,
    renderPaymentBtnDetailed,
    submitEnabled,
    submissionErrorsCount,
  } = props

  let renderButtonContent = []

  if (
    process.env.REACT_APP_COMPONENT_PAYMENT_BUTTON === 'button-detailed' &&
    renderPaymentBtnDetailed
  ) {
    renderButtonContent.push(renderPaymentBtnDetailed)
  } else if (!submitEnabled) {
    renderButtonContent.push(
      <Fragment key={`submit-button`}>
        {hotelLabels.validFormMessage ? hotelLabels.validFormMessage : 'Please complete all required fields (*) to proceed'}
        {submissionErrorsCount && submissionErrorsCount > 0 &&
          <span className="submission-errors-count u-font-bold">
            &nbsp;({submissionErrorsCount} {hotelLabels.remaining ? hotelLabels.remaining : 'Remaining'})
          </span>
        }
      </Fragment>
    )
  } else {
    renderButtonContent.push(hotelLabels.bookMyStay ? hotelLabels.bookMyStay : 'Book My Stay')
  }

  const isLoading = transactionTokenLoading || reservationLoading || pspSessionIdLoading || dsp2TransactionLoading

  return (
    !isFormExternal &&
    isLoading ?
      <BkFlowMaterialLoader />
    : !isFormExternal ?
      <button
        disabled={ !submitEnabled || isLoading }
        className="btn btn-primary btn-xl top-sm"
        onClick={() => handleSubmitReservations()}
      >
        {renderButtonContent}
      </button>
    : isFormExternal ?
      <button
        disabled={ !submitEnabled || isLoading }
        className="btn btn-primary btn-xl submit-external top-sm"
        onClick={() => handleSubmitReservations()}
      >
        {isLoading ?
          <BkFlowMaterialLoader
            parentClasses='u-txt-center'
            color={'#000'}
            size={15}
          />
        :
          renderButtonContent
        }
      </button>
    :
      null
  )
}

export default BkFlowPaymentSubmit



// WEBPACK FOOTER //
// ./src/components/payment/BkFlowPaymentSubmit.js